export default __webpack_public_path__ + "static/media/industrialist_big.9a9a312d.jpg";